import { NormalizedEntity } from 'Interfaces/Common';
import { Document } from 'Interfaces/Document';
import { createReducer } from 'typesafe-actions';

import {
  getSignerDocument,
  sendCodeAccess,
  sendDocumentOut,
  sendOutEmbedDocument,
} from '../documentSign/actionCreators';

import {
  activateTemplate,
  addTemplateToApi,
  cleanFileData,
  copyDocument,
  createDocument,
  createDocumentByExistTemplate,
  createDocumentFromFormRequest,
  deleteDocument,
  disableForm,
  enableForm,
  getAllDocuments,
  getAllTemplates,
  getDocument,
  getDocumentConvertionStatus,
  getEmbedDocument,
  getFormRequest,
  getFormRequests,
  mergeTemplate,
  removeTemplateFromApi,
  replicateTemplate,
  revertDocument,
  signSeparateDocument,
  signSeparateDocumentActivities,
  updateDocument,
  updateDocumentByExistTemplate,
  updateEmbedDocument,
  uploadDocument,
} from './actionCreators';

export default createReducer({} as NormalizedEntity<Document>)
  .handleAction(
    [
      createDocument.success,
      getSignerDocument.success,
      addTemplateToApi.success,
      removeTemplateFromApi.success,
      sendCodeAccess.success,
      getDocument.success,
      updateDocument.success,
      cleanFileData.success,
      sendDocumentOut.success,
      createDocumentByExistTemplate.success,
      updateDocumentByExistTemplate.success,
      copyDocument.success,
      activateTemplate.success,
      revertDocument.success,
      replicateTemplate.success,
      mergeTemplate.success,
      createDocumentFromFormRequest.success,
      getFormRequest.success,
      disableForm.success,
      enableForm.success,
      sendOutEmbedDocument.success,
      getEmbedDocument.success,
      updateEmbedDocument.success,
    ],
    (state, action) => ({
      ...state,
      [action.payload.id]: action.payload,
    }),
  )
  .handleAction([uploadDocument.success], (state, action) => ({
    ...state,
    [action.payload.document.id]: {
      ...state[action.payload.document.id],
      ...action.payload.document,
    },
  }))
  .handleAction(
    [
      getDocumentConvertionStatus.success,
      signSeparateDocument.success,
      signSeparateDocumentActivities.success,
    ],
    (state, action) => ({
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        ...action.payload,
      },
    }),
  )
  .handleAction(getFormRequests.success, (state, action) => ({
    ...action.payload.documents,
  }))
  .handleAction(getAllDocuments.success, (state, action) => ({ ...action.payload }))
  .handleAction(getAllTemplates.success, (state, action) => ({
    ...state,
    ...action.payload,
  }))
  .handleAction(deleteDocument.success, (state, action) => {
    const deleteId = action.payload.documentId;
    const newState = { ...state };
    delete newState[deleteId];

    return newState;
  });
